import { render, staticRenderFns } from "./markdownToVue.vue?vue&type=template&id=11dc0e8c&"
import script from "./markdownToVue.vue?vue&type=script&lang=js&"
export * from "./markdownToVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports